import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import globalSlice from '@App/reducers/global/globalSlice';
import profileSlice from '@App/reducers/profile/profileSlice';
import cartSlice from '@App/reducers/cart/cartSlice';
import storage from 'redux-persist/lib/storage';
import { persistStore, persistReducer } from 'redux-persist';

//import globalReducer from '@Features/global/globalSlice';

const persistConfig = {
	key: 'global',
	storage,
	whitelist: ['currency'], 
  };
  
  const persistedGlobalReducer = persistReducer(persistConfig, globalSlice);

export const store = configureStore({
	reducer: {
		global:persistedGlobalReducer,
		profile:profileSlice,
		cart: cartSlice,
	},
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
	ReturnType,
	RootState,
	unknown,
	Action<string>
>;
